module.exports = __webpack_public_path__ + "561afd071c91966b087392b58a66204d.png";